<script setup lang="ts">
import './assets/style.scss'
import {
  WAdminMenu,
  WContentHeader,
  WEventsLast,
  WHeader,
  WObjectHeader,
  WObjectMenu,
  WScheduleHeader,
  WSchedulesMenu,
  WSideBar,
  WToasts,
  WUserInfo,
} from '@/widgets'
import { VConfirm, VNotification } from '@/shared/ui'
import { ref } from 'vue'
import { ObjectReplaceForm } from '@/features/Object/ObjectReplace'
import { ObjectAddForm } from '@/features/Object/ObjectAdd'
import { useRoute } from 'vue-router'
import { useAuth } from '@/entities/Auth'
import { ScheduleCreateForm } from '@/features/Schedule/ScheduleCreate'
import { ScheduleEditForm } from '@/features/Schedule/ScheduleEdit'
import { ScheduleCopyForm } from '@/features/Schedule/ScheduleCopy'
import { WGlobalSearch } from '@/widgets/GlobalSearch'

const route = useRoute()
const { loadAuth, isTab } = useAuth()
const sideBarIsClose = ref(true)

/**
 * Вычисляем находимся ли мы на нужной странице
 */
const isType = (type: string) => {
  return route.matched.some(({ path }) => path.includes(type))
}

const { isSuccess } = loadAuth()

/** Определение слотов */
defineSlots<{
  default: (props: {}) => any
}>()
</script>

<template>
  <VNotification position="right" />
  <VConfirm />

  <template v-if="isSuccess">
    <WHeader>
      <template #user>
        <WUserInfo />
      </template>

      <template #menu>
        <WObjectMenu v-if="isType('objects')" />
        <WSchedulesMenu v-else-if="isType('schedules')" />
        <WAdminMenu v-else />
      </template>
    </WHeader>

    <div class="dash-layout__grid">
      <WSideBar v-if="isTab('TREE')" v-model="sideBarIsClose" />

      <div
        class="dash-layout__content"
        :class="{
          'dash-layout__content_compact': !sideBarIsClose,
          'dash-layout__content_full': !isTab('TREE'),
        }"
      >
        <WObjectHeader v-if="isType('objects')" />
        <WScheduleHeader v-else-if="isType('schedules')" />
        <WContentHeader v-else />

        <div class="dash-layout__main">
          <slot />
        </div>
      </div>
    </div>
  </template>

  <ObjectReplaceForm />
  <ObjectAddForm />

  <ScheduleCreateForm />
  <ScheduleEditForm />
  <ScheduleCopyForm />

  <WToasts />
  <WEventsLast />
  <WGlobalSearch />
</template>
